import _extends from "@babel/runtime-corejs3/helpers/extends";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import * as _ from "../util/lodash";
var promptTypes = {
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error'
};

var messageTypes = _extends({}, promptTypes, {
  SUCCESS: 'success'
});

promptTypes.ALL = _valuesInstanceProperty(_).call(_, promptTypes);
messageTypes.ALL = _valuesInstanceProperty(_).call(_, messageTypes);
export { messageTypes, promptTypes };
//# sourceMappingURL=message-types.js.map